/* ScentStation AU – Scent Match quiz data v1.2
 *
 * Edit this file to change how the quiz scores and pairs scents.
 * Keys are the 3-digit scent number in each diffuser's title ("Scent 011 - Inspired by …"),
 * the same convention the Double buy box uses.
 *
 * fam   – how strongly the scent sits in each family, 0–3
 *         fresh | sweet | woody (warm, woody, leather, spice) | floral | fruity
 * int   – strength: 1 subtle, 2 noticeable, 3 statement
 * lean  – masc | fem | unisex
 * vibes – daily (commute), date (nights out), road (long drives), odour (kids, pets, gym gear),
 *         weekend (the weekender: a pride-and-joy car for sunny days and special occasions)
 * line  – one-line description shown on the result card
 * pair  – the curated second scent for the Double. Set the product's custom.default_pair
 *         metafield to the same scent so the product page matches the quiz.
 * pairWhy – one line shown under the pairing
 *
 * perfumes – what people can pick at "What do you wear?"
 *   exact: the scent inspired by that perfume
 *   close: nearest scents (first is the strongest match)
 */
window.ScentMatchData = {
  scents: {
    "001": { fam: { woody: 3, sweet: 1, floral: 1 }, int: 3, lean: "unisex", vibes: ["date", "weekend"],
      line: "Smoky oud, deep amber and rose. Rich, refined, lingering.",
      pair: "005", pairWhy: "Two niche icons: smoky oud by day, glowing amber by night." },
    "002": { fam: { fruity: 2, fresh: 2, woody: 2 }, int: 2, lean: "masc", vibes: ["daily", "road", "odour", "weekend"],
      line: "Pineapple-bright opening over smoky birch and leather.",
      pair: "007", pairWhy: "His fruity-smoky classic, her juicy berry sweetness." },
    "003": { fam: { fruity: 3, fresh: 2, sweet: 1 }, int: 3, lean: "unisex", vibes: ["daily", "odour"],
      line: "Zesty citrus and juicy fruit on a soft musky vanilla base. Just-detailed fresh.",
      pair: "015", pairWhy: "Fruit-forward and sweet: one bright, one candy-cosy." },
    "004": { fam: { fresh: 3, woody: 1 }, int: 2, lean: "masc", vibes: ["daily", "road"],
      line: "Crisp citrus, airy green tea and a smooth amber dry-down.",
      pair: "014", pairWhy: "Clean and modern: crisp citrus meets creamy white florals." },
    "005": { fam: { sweet: 3, woody: 2, floral: 1 }, int: 3, lean: "unisex", vibes: ["date", "weekend"],
      line: "Luminous amber woods with an airy, almost sugared sweetness.",
      pair: "001", pairWhy: "Two niche icons: glowing amber by day, smoky oud by night." },
    "006": { fam: { sweet: 3, woody: 1 }, int: 2, lean: "unisex", vibes: ["date", "daily"],
      line: "Warm spice melting into vanilla, rum and cacao. Dessert in the car.",
      pair: "010", pairWhy: "A cosy gourmand duo: vanilla-rum and honey-tobacco." },
    "007": { fam: { fruity: 3, sweet: 2 }, int: 2, lean: "fem", vibes: ["daily"],
      line: "Juicy berries and candy sweetness over soft woods and musk.",
      pair: "002", pairWhy: "Her juicy berries, his fruity-smoky classic." },
    "008": { fam: { sweet: 3, woody: 1 }, int: 2, lean: "fem", vibes: ["date", "daily"],
      line: "Sweet amber and smooth vanilla woods. Warm, cosy, long-lasting.",
      pair: "009", pairWhy: "Soft vanilla against dark leather: a classic his and hers." },
    "009": { fam: { woody: 3 }, int: 3, lean: "masc", vibes: ["date", "weekend"],
      line: "Rich leather and black suede warmed with cardamom. Dark and luxurious.",
      pair: "008", pairWhy: "Dark leather against soft vanilla: a classic his and hers." },
    "010": { fam: { sweet: 3, woody: 2 }, int: 3, lean: "masc", vibes: ["road", "weekend"],
      line: "Honey and vanilla over tobacco and lavender. Smooth and grown-up.",
      pair: "006", pairWhy: "A cosy gourmand duo: honey-tobacco and vanilla-rum." },
    "011": { fam: { fresh: 3, woody: 1 }, int: 3, lean: "masc", vibes: ["daily", "road", "odour"],
      line: "Bergamot, pepper and ambroxan. The world's best-selling fresh, in your car.",
      pair: "013", pairWhy: "The best-selling his and hers: fresh and spicy meets sweet and bold." },
    "012": { fam: { woody: 2, sweet: 2, fresh: 1 }, int: 3, lean: "unisex", vibes: ["date", "odour"],
      line: "High-impact tonka and amber with a fresh, spicy edge.",
      pair: "008", pairWhy: "Both built on warm tonka and vanilla: bold and cosy." },
    "013": { fam: { sweet: 2, floral: 2, woody: 1 }, int: 3, lean: "fem", vibes: ["date"],
      line: "Creamy vanilla and white florals with cacao and almond. Night-out luxe.",
      pair: "011", pairWhy: "The best-selling his and hers: sweet and bold meets fresh and spicy." },
    "014": { fam: { floral: 2, sweet: 2, fresh: 1 }, int: 2, lean: "fem", vibes: ["daily"],
      line: "White florals and creamy vanilla, lifted by bright citrus.",
      pair: "018", pairWhy: "Fresh florals for both: creamy vanilla and bright orange blossom." },
    "015": { fam: { sweet: 3, fruity: 2 }, int: 3, lean: "fem", vibes: ["daily"],
      line: "Vanilla and sugary sweetness with a soft fruity warmth. Playful and cosy.",
      pair: "003", pairWhy: "Sweet and fruit-forward: one candy-cosy, one bright." },
    "016": { fam: { floral: 2, sweet: 2, fruity: 1 }, int: 2, lean: "fem", vibes: ["daily", "date"],
      line: "Blackcurrant, rose and woody vanilla. Smooth and elegant.",
      pair: "017", pairWhy: "Elegant and fresh: rose-vanilla with bright grapefruit." },
    "017": { fam: { fresh: 3, fruity: 1, woody: 1 }, int: 3, lean: "masc", vibes: ["road", "odour", "weekend"],
      line: "Bright grapefruit over a smooth woody-amber base. Fresh and confident.",
      pair: "016", pairWhy: "Fresh and elegant: bright grapefruit with rose-vanilla." },
    "018": { fam: { fresh: 2, floral: 2, woody: 1 }, int: 1, lean: "masc", vibes: ["daily"],
      line: "Bergamot and orange blossom on soft woods. Clean and understated.",
      pair: "014", pairWhy: "Fresh florals for both: orange blossom and creamy vanilla." },
    "019": { fam: { sweet: 2, fresh: 2, woody: 1 }, int: 3, lean: "masc", vibes: ["date", "daily"],
      line: "Vanilla and lavender over smoky woods. Bold but smooth.",
      pair: "020", pairWhy: "The original his and hers: Born in Roma Uomo and Donna." },
    "020": { fam: { sweet: 2, floral: 2, woody: 1 }, int: 2, lean: "fem", vibes: ["date", "daily", "weekend"],
      line: "Sweet vanilla and jasmine on a soft amber base. Warm and elegant.",
      pair: "019", pairWhy: "The original his and hers: Born in Roma Donna and Uomo." }
  },

  perfumes: [
    // Exact matches (the perfume each scent is inspired by)
    { name: "LV Ombré Nomade", alt: ["ombre nomade", "louis vuitton ombre nomade"], exact: "001" },
    { name: "Creed Aventus", alt: ["aventus"], exact: "002" },
    { name: "Xerjoff Erba Pura", alt: ["erba pura"], exact: "003" },
    { name: "Louis Vuitton Imagination", alt: ["lv imagination", "imagination"], exact: "004" },
    { name: "Baccarat Rouge 540", alt: ["br540", "br 540", "baccarat", "mfk baccarat"], exact: "005" },
    { name: "Dior Vanilla Diorama", alt: ["vanilla diorama"], exact: "006" },
    { name: "Burberry Her", alt: ["burberry her"], exact: "007" },
    { name: "Kayali Vanilla 28", alt: ["vanilla 28", "kayali vanilla"], exact: "008" },
    { name: "Tom Ford Ombré Leather", alt: ["ombre leather", "tom ford leather"], exact: "009" },
    { name: "Xerjoff Naxos", alt: ["naxos"], exact: "010" },
    { name: "Dior Sauvage", alt: ["sauvage"], exact: "011" },
    { name: "Montale Arabians Tonka", alt: ["arabians tonka", "montale"], exact: "012" },
    { name: "Carolina Herrera Good Girl", alt: ["good girl", "ch good girl"], exact: "013" },
    { name: "Prada Paradoxe Intense", alt: ["paradoxe", "paradox", "prada paradoxe"], exact: "014" },
    { name: "Kayali Vanilla Candy Rock Sugar 42", alt: ["candy rock sugar", "kayali 42", "rock sugar"], exact: "015" },
    { name: "Giorgio Armani Sì", alt: ["armani si", "armani sì"], exact: "016" },
    { name: "Bvlgari Tygar", alt: ["tygar", "bulgari tygar"], exact: "017" },
    { name: "YSL MYSLF", alt: ["myslf", "myself"], exact: "018" },
    { name: "Valentino Uomo Born in Roma", alt: ["born in roma uomo", "valentino uomo", "uomo born in roma"], exact: "019" },
    { name: "Valentino Donna Born in Roma", alt: ["born in roma donna", "valentino donna", "donna born in roma"], exact: "020" },

    // Close matches (popular perfumes we don't make, mapped to the nearest scents)
    { name: "Chanel Bleu de Chanel", alt: ["bleu de chanel", "bdc", "bleu"], close: ["011", "004"] },
    { name: "Giorgio Armani Acqua di Giò", alt: ["acqua di gio", "adg", "acqua di gio profumo"], close: ["004", "017"] },
    { name: "YSL Y", alt: ["ysl y", "y edp"], close: ["011", "004"] },
    { name: "Versace Dylan Blue", alt: ["dylan blue"], close: ["011", "017"] },
    { name: "Prada Luna Rossa", alt: ["luna rossa", "prada l'homme", "prada lhomme"], close: ["004", "018"] },
    { name: "Armaf Club de Nuit Intense", alt: ["club de nuit", "cdnim", "cdni"], close: ["002"] },
    { name: "Mancera Cedrat Boisé", alt: ["cedrat boise"], close: ["002", "017"] },
    { name: "Versace Eros", alt: ["eros"], close: ["019", "010"] },
    { name: "Jean Paul Gaultier Le Male", alt: ["le male", "le male elixir", "jpg le male"], close: ["019", "010"] },
    { name: "Parfums de Marly Layton", alt: ["layton", "pdm layton"], close: ["019", "010"] },
    { name: "Giorgio Armani Code", alt: ["armani code"], close: ["019", "012"] },
    { name: "Paco Rabanne 1 Million", alt: ["1 million", "one million"], close: ["010", "012"] },
    { name: "Tom Ford Tobacco Vanille", alt: ["tobacco vanille", "tobacco vanilla"], close: ["010", "006"] },
    { name: "Maison Margiela Jazz Club", alt: ["jazz club", "replica jazz club"], close: ["010", "009"] },
    { name: "Kilian Angels' Share", alt: ["angels share", "angel's share"], close: ["006", "010"] },
    { name: "Lattafa Khamrah", alt: ["khamrah"], close: ["006", "010"] },
    { name: "Le Labo Santal 33", alt: ["santal 33", "santal"], close: ["009", "001"] },
    { name: "Ariana Grande Cloud", alt: ["cloud", "ariana cloud"], close: ["005", "015"] },
    { name: "Sol de Janeiro Cheirosa 62", alt: ["cheirosa", "brazilian crush", "sol de janeiro"], close: ["015", "008"] },
    { name: "YSL Black Opium", alt: ["black opium"], close: ["013", "020"] },
    { name: "Lancôme La Vie Est Belle", alt: ["la vie est belle", "lancome"], close: ["013", "008"] },
    { name: "YSL Libre", alt: ["libre"], close: ["020", "014"] },
    { name: "Paco Rabanne Lady Million", alt: ["lady million", "fame"], close: ["013", "016"] },
    { name: "Viktor&Rolf Flowerbomb", alt: ["flowerbomb"], close: ["016", "020"] },
    { name: "Chanel Coco Mademoiselle", alt: ["coco mademoiselle", "coco"], close: ["016", "014"] },
    { name: "Chanel Chance", alt: ["chance", "chance eau tendre"], close: ["014", "018"] },
    { name: "Dior J'adore", alt: ["jadore", "j'adore"], close: ["014", "020"] },
    { name: "Marc Jacobs Daisy", alt: ["daisy"], close: ["007", "016"] },
    { name: "Tom Ford Lost Cherry", alt: ["lost cherry"], close: ["007", "015"] }
  ],

  // Quick-pick chips shown before anyone types
  popular: ["Dior Sauvage", "Creed Aventus", "Baccarat Rouge 540", "Chanel Bleu de Chanel",
            "YSL Libre", "Carolina Herrera Good Girl", "Kayali Vanilla 28", "Versace Eros"]
};
